<template>
  <header class="shared-section-header">
    <div>
      <h2 class="pl-4 mb-3 shared-section-header-heading sm:pl-0">{{ title }}</h2>
      <h3 class="flex items-center font-bold text-ricoma-gray-600">
        <div>{{ serie.name }}</div>
        <div v-if="videoTitle" class="flex items-center">
          <span class="mx-4"><VSvgIcon name="chevron-double-right" /></span>
          <span>{{ videoTitle }}</span>
        </div>
      </h3>
    </div>
    <div v-if="showVideoDetails" class="ml-auto">
      <button
        class="flex items-center justify-center h-12 px-5 text-sm text-white uppercase bg-gray-900 rounded"
        @click="$emit('show')"
      >
        <VSvgIcon name="plus" class="mr-1" />
        Add Section
      </button>
    </div>
  </header>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'SeriesHeader',
  components: { VSvgIcon },
  props: {
    title: {
      type: String,
      required: true,
    },
    serie: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    videoTitle: {
      type: String,
      required: false,
      default: '',
    },
    showVideoDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
